import { RadioTileCheckmark, RadioTileInput, RadioTileLabel } from './styles'

export interface RadioTileProps<T> {
  label: string
  value: T
  name: string
  onClick: (val: this['value']) => void
  defaultChecked?: boolean
}

function RadioTile<T extends string>({
  label,
  onClick,
  ...rest
}: RadioTileProps<T>) {
  const handleClick = () => onClick(rest.value)

  return (
    <RadioTileLabel onClick={handleClick}>
      <RadioTileInput type="radio" {...rest} />
      <RadioTileCheckmark>{label}</RadioTileCheckmark>
    </RadioTileLabel>
  )
}

export default RadioTile
